export default __webpack_public_path__ + "static/bluefilingdust-ee49ca7cdd44fa1b5d6abb334a56d031.png";